function hashCode(text: string): number {
  let hash = 0,
    i,
    chr;
  if (text.length === 0) return hash;
  for (i = 0; i < text.length; i++) {
    chr = text.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export function derivedHue(text: string): number {
  return (hashCode(text) + 200) % 360;
}

export function derivedColor(
  text: string,
  saturation = 60,
  lightness = 40
): string {
  const hue = derivedHue(text);
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
